/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OnlineStatusPercentageDto
 */
export interface OnlineStatusPercentageDto {
    /**
     *
     * @type {Date}
     * @memberof OnlineStatusPercentageDto
     */
    date?: Date;
    /**
     *
     * @type {number}
     * @memberof OnlineStatusPercentageDto
     */
    onlinePercentage?: number;
    /**
     *
     * @type {number}
     * @memberof OnlineStatusPercentageDto
     */
    offlinePercentage?: number;
    /**
     *
     * @type {number}
     * @memberof OnlineStatusPercentageDto
     */
    remainingPercentage?: number;
}

/**
 * Check if a given object implements the OnlineStatusPercentageDto interface.
 */
export function instanceOfOnlineStatusPercentageDto(
    value: object,
): value is OnlineStatusPercentageDto {
    return true;
}

export function OnlineStatusPercentageDtoFromJSON(
    json: any,
): OnlineStatusPercentageDto {
    return OnlineStatusPercentageDtoFromJSONTyped(json, false);
}

export function OnlineStatusPercentageDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OnlineStatusPercentageDto {
    if (json == null) {
        return json;
    }
    return {
        date: json["date"] == null ? undefined : new Date(json["date"]),
        onlinePercentage:
            json["onlinePercentage"] == null
                ? undefined
                : json["onlinePercentage"],
        offlinePercentage:
            json["offlinePercentage"] == null
                ? undefined
                : json["offlinePercentage"],
        remainingPercentage:
            json["remainingPercentage"] == null
                ? undefined
                : json["remainingPercentage"],
    };
}

export function OnlineStatusPercentageDtoToJSON(
    value?: OnlineStatusPercentageDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        onlinePercentage: value["onlinePercentage"],
        offlinePercentage: value["offlinePercentage"],
        remainingPercentage: value["remainingPercentage"],
    };
}
